import React from 'react'
import { FileUpload } from '../../../../../../../../../../itrust_common/components/form'
import { change, Field, formValueSelector } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { visionInsuranceClaimFormUpdate } from '../../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { withOrdersInsuranceId } from '../../../../../../../../../../components/authorised/order/claimFormDropdownUtils'

import { getAttachments, getAttachmentSrc } from '../../../eyeMedHelper'

function FrameDocuments(props) {
  const { frameMedia, visionInsuranceClaimForm, saving, editing } = props
  const dispatch = useDispatch()
  const attachments = getAttachments(visionInsuranceClaimForm, 'frame')

  const handleMediaUpload = async (val) => {
    const { name, ...rest } = val || {}
    await dispatch(visionInsuranceClaimFormUpdate({
      ...visionInsuranceClaimForm,
      attachments_attributes: [...attachments, { ...rest, metadata: 'frame' }]
    }, withOrdersInsuranceId({ include: '*' }, editing?.orders_insurance_id)))
    dispatch(change('EyeMedClaimForm', 'frames[attachments_attributes]', null))
  }

  const handleRemoveMedia = (obj) => {
    dispatch(visionInsuranceClaimFormUpdate({
      ...visionInsuranceClaimForm,
      attachments_attributes: [{ ...obj, _destroy: true }]
    }, withOrdersInsuranceId({ include: '*' }, editing?.orders_insurance_id)))
  }

  return (
    <div className='col-12'>
      <p className='mb-5'>
        <strong>Supporting Documentation: </strong> Please choose supporting documentation for the associated claim.
      </p>
      <div className='row'>
        <Field type='file' label="Upload" name="attachments_attributes" component={FileUpload} wrapperClasses={`col-3 form-group ${saving ? 'disabled' : ''}`} imageClasses="py-3 px-5 uploaded-file-width" key={frameMedia} onChangeHook={(val) => handleMediaUpload(val)} />
        <div className='col-9'>
          <div className="row mx-0 py-5">
            <p className='col-12 mb-0'>Uploaded Documents:</p>
            {attachments.map((item, index) => (
              <div key={item.id || index} className='col-3 d-flex flex-column align-items-center position-relative'>
                <embed src={getAttachmentSrc(item)} className="pt-5 img-fluid" style={{ height: '12rem', objectFit: "fit" }}></embed>
                <p className='text-danger bg-light mb-0 pointer w-100 text-center py-2' onClick={() => handleRemoveMedia(item)} style={{ right: '0', top: '1rem' }}><i className="la la-trash" /></p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

const selector = formValueSelector('EyeMedClaimForm')

const mapStateToProps = (state) => ({
  frameMedia: selector(state, 'frames[attachments_attributes]'),
  saving: state.visionInsuranceClaimForm.saving,
  editing: state.visionInsuranceClaimForm.editing,
})

export default connect(mapStateToProps)(FrameDocuments)
